import React, { useMemo } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import Navigator from '../../components/common/Navigator'
import { Button } from '../../components/common'
import { useTranningCalender } from '../Departments/learning/program/api'

function Nbfc() {
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const queryName = (params.get('name') || '').trim()
  const effectiveName = queryName || 'NBFC'

  const filters = effectiveName
    ? { name: effectiveName, program_name: effectiveName, title: effectiveName }
    : {}

  const { data, isLoading, isError } = useTranningCalender(filters)
  const programs = data?.data || []

  const filteredPrograms = useMemo(() => {
    const n = effectiveName.toLowerCase()
    return programs.filter((p: any) =>
      String(p?.name || '')
        .toLowerCase()
        .includes(n)
    )
  }, [programs, effectiveName])

  const getProgramId = (item: any) =>
    item?.id ?? item?.program_id ?? item?.programId

  if (isLoading) return <div className="text-center py-10">Loading...</div>
  if (isError)
    return (
      <div className="text-center py-10 text-red-500">
        Failed to load programs.
      </div>
    )

  return (
    <div className="lg:w-11/12 lg:mx-auto mx-4 py-6 font-sans">
      <div className="mb-6">
        <Navigator
          slug="NBFC"
          // middle_title="Initiatives"
          title="NBFC"
        />
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Norka Business Facilitation Center (NBFC)
        </h1>
        <p className="text-gray-800 mb-3 ">
          Norka Business Facilitation Center (NBFC) is an initiative
          conceptualized by Government of Kerala for offering comprehensive
          support services and advisories for robust investment growth. It seeks
          to facilitate investments of Non-Resident Keralites (NRK`s) in
          commencing business ventures in Kerala. The Norka Business
          Facilitation Center (NBFC) help assess business opportunities
          available and their various options so that focused attention could be
          exercised.
        </p>
        <p className="text-gray-800 mb-3">
          The Norka-Roots identified the Kerala Institute for Entrepreneurship
          Development (KIED), an autonomous body under the Industries and
          Commerce Department, Government of Kerala as the Managing Partner of
          the NBFC to change the centre to an excellent supporting contact point
          for the investors and entrepreneurs.
        </p>
        <hr className="border-t-2 border-primaryBlue mb-6" />

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Mission</h2>
          <p className="text-gray-800 leading-7">
            To be the Professional Agency for NRKs and Returnees in Inspiring,
            Planning, Starting, Managing and Growing their Business inside
            Kerala.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            Services Offered by NBFC
          </h2>
          <ul className="list-disc pl-6 space-y-1 text-gray-800 leading-7">
            <li>Assistance in formulating business related ideas.</li>
            <li>
              Information on loan schemes and terms and conditions of financial
              institutions / banks.
            </li>
            <li>
              Information on capital subsidy and interest subsidy schemes of
              Norka-Roots / Government of Kerala.
            </li>
            <li>
              Information on subsidies of Central Government/ Central Government
              Agencies.
            </li>
            <li>Assistance in preparing project profile / business plan.</li>
            <li>
              Providing handouts / materials on relevant areas of Business.
            </li>
            <li>
              Assistance for Business Registration / Licensing Information
              through Single Window System (K-SWIFT).
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            Entrepreneurship Programs
          </h2>
          <ul className="list-disc pl-6 space-y-1 text-gray-800 leading-7">
            <li>
              Entrepreneurship Development Programme for NRKs / Return Pravasis
              at free of cost.
            </li>
            <li>Business Clinics for existing entrepreneurs.</li>
            <li>Entrepreneurship Training in specific sectors.</li>
            <li>Technology Management Development Programme.</li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            Pravasi Investors Meet
          </h2>
          <p className="text-gray-800 leading-7">
            An investment meeting is organized to collect investment from
            non-resident Malayalis and start ventures in Kerala.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            Handbooks Published
          </h2>
          <p className="text-gray-800 leading-7">
            Comprehensive booklets related to Business Investment /
            Entrepreneurship.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            Contact Us
          </h2>
          <div className="text-gray-800 leading-7">
            <p>
              <span className="font-semibold">Email:</span>{' '}
              nbfc.norka@kerala.gov.in ; nbfc.coordinator@gmail.com
            </p>
            <p>
              <span className="font-semibold">NBFC Office:</span> 0471-2770534
            </p>
            <p>
              <span className="font-semibold">NBFC Mob:</span> 0091-8592958677
            </p>
            <p>
              <span className="font-semibold">Manager (Projects) Mob:</span>{' '}
              0091-9446022519
            </p>
            <p>
              <span className="font-semibold">
                Sr. Programme Coordinator Mob:
              </span>{' '}
              0091-9446550872
            </p>
          </div>
        </section>

        <hr className="border-t-2 border-primaryBlue" />
        <h2 className="text-xl font-semibold text-gray-900 mt-4 mb-2">
          Programs
        </h2>
        <p className="text-gray-700 mb-3">
          {queryName
            ? `Programs matching "${effectiveName}"`
            : 'Showing NBFC-related programs. Choose one to apply.'}
        </p>
      </div>

      {filteredPrograms.length === 0 ? (
        <div className="text-gray-500">No matching programs found.</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredPrograms.map((p: any) => (
            <div
              key={getProgramId(p) ?? p.name}
              className="bg-white border rounded-lg shadow p-5 flex flex-col"
            >
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {p.name}
              </h3>
              {p.mode && (
                <p className="text-sm text-gray-600 mb-4">Mode: {p.mode}</p>
              )}
              <div className="mt-auto">
                <Button
                  label="Apply Now"
                  outlined
                  className="border border-LightGreen text-LightGreen px-4 py-2 hover:bg-LightGreen hover:text-white text-sm"
                  onClick={() => {
                    const pid = getProgramId(p)
                    if (pid) navigate(`/departments/learning/form/${pid}`)
                    else alert('Selected program does not have a valid ID')
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default Nbfc
